import {createAction} from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import {userAccessTokenSelector} from "../../../security";

const workflowController = new WorkFlowController();

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const fetchAllContactsRequested: Action = createAction(
  ActionTypes.FETCH_CONTACTS_REQUESTED
);

export const fetchAllContactsReceived: Action = createAction(
  ActionTypes.FETCH_CONTACTS_RECEIVED
);

export const fetchAllContactsFailed: Action = createAction(
  ActionTypes.FETCH_CONTACTS_FAILED
)

const fetchAllContactsAPI = async (options) => await workflowController.findWhere("contact", {}, options);
export const fetchAllContacts = () => async (dispatch, getState) => {
  dispatch(fetchAllContactsRequested());
  try {
    const contacts = await fetchAllContactsAPI({token: userAccessTokenSelector(getState())});
    dispatch(fetchAllContactsReceived(contacts));
  } catch (err) {
    dispatch(fetchAllContactsFailed());
  }
};

export const fetchContactRequested: Action = createAction(
  ActionTypes.FETCH_CONTACT_REQUESTED
);

export const fetchContactReceived: Action = createAction(
  ActionTypes.FETCH_CONTACT_RECEIVED
);

export const fetchContactFailed: Action = createAction(
  ActionTypes.FETCH_CONTACT_FAILED
)

const fetchContactAPI = async (contactId, options) => await workflowController.findOne("contact", {contactId: contactId}, options)
export const fetchContact = contactId => async (dispatch, getState) => {
  dispatch(fetchContactRequested(contactId));
  try {
    const contact = await fetchContactAPI(contactId,  {token: userAccessTokenSelector(getState())})
    dispatch(fetchContactReceived(contact));
  } catch (err) {
    dispatch(fetchContactFailed());
  }
};

export const createContactRequested: Action = createAction(
  ActionTypes.CREATE_CONTACT_REQUESTED
);

export const createContactReceived: Action = createAction(
  ActionTypes.CREATE_CONTACT_RECEIVED
);

export const createContactFailed: Action = createAction(
  ActionTypes.CREATE_CONTACT_FAILED
)


const createContactAPI = async (email, firstName, lastName, options) => await workflowController.create("contact", {email, firstName, lastName}, options);
export const createContact = (email, firstName, lastName) => {
  return async (dispatch, getState) => {
    dispatch(createContactRequested());
    try {
      const handledCommand = await createContactAPI(email, firstName, lastName,  {token: userAccessTokenSelector(getState())})
      dispatch(createContactReceived());
      dispatch(fetchContact(handledCommand.contactId))
      return handledCommand.contactId;
    } catch (err) {
      dispatch(createContactFailed(err.message[0].msg));
    }
  };
};

export const updateContactRequested: Action = createAction(
  ActionTypes.UPDATE_CONTACT_REQUESTED
);

export const updateContactReceived: Action = createAction(
  ActionTypes.UPDATE_CONTACT_RECEIVED
);

export const updateContactFailed: Action = createAction(
  ActionTypes.UPDATE_CONTACT_FAILED
)

const updateContactAPI = async (contactId, email, firstName, lastName, options) => await workflowController.execute('contact', null,'update', { contactId, email, firstName, lastName, options});
export const updateContact = (contactId, email, firstName, lastName) => {
  return async (dispatch, getState) => {
    dispatch(updateContactRequested());
    try {
      const handledCommand = await updateContactAPI(contactId, email, firstName, lastName, {token: userAccessTokenSelector(getState())})
      dispatch(updateContactReceived());
      dispatch(fetchContact(handledCommand.contactId))
    } catch (err) {
      dispatch(updateContactFailed(err.message[0].msg));
    }
  };
};

export const fetchAccountContactsRequested: Action = createAction(ActionTypes.FETCH_BILLING_ACCOUNT_CONTACT_REQUESTED);
export const fetchAccountContactsReceived: Action = createAction(ActionTypes.FETCH_BILLING_ACCOUNT_CONTACT_RECEIVED);
export const fetchAccountContactsFailed: Action = createAction(ActionTypes.FETCH_BILLING_ACCOUNT_CONTACT_FAILED)

const fetchAccountContactsAPICall = (billingAccountId, options) => workflowController.findWhere("billingAccountContact", { billingAccountId, deleted: false }, options)
export const fetchAccountContacts = (billingAccountId) => async (dispatch, getState) => {
  dispatch(fetchAccountContactsRequested());
  try {
    const results = await fetchAccountContactsAPICall(billingAccountId, {token: userAccessTokenSelector(getState())})
    dispatch(fetchAccountContactsReceived(results.length ? results : null))
  } catch(err) {
    dispatch(fetchAccountContactsFailed(err.message))
  }
};



// WEBPACK FOOTER //
// ./src/features/contact/store/contactsActions.js